import { render, staticRenderFns } from "./FactorFormModal.vue?vue&type=template&id=2ce1d2fc&scoped=true"
import script from "./FactorFormModal.vue?vue&type=script&lang=js"
export * from "./FactorFormModal.vue?vue&type=script&lang=js"
import style0 from "./FactorFormModal.vue?vue&type=style&index=0&id=2ce1d2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce1d2fc",
  null
  
)

export default component.exports